import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,FormControl,Select as MaterialSelect  ,Box ,TextField
  ,RadioGroup,Radio, Grid, Typography, FormLabel, FormControlLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../../funciones/ClienteAxios";
import Modal from '../../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
import Relojes from './Relojes';
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const NvoEditIncidencia = ({modalAbierto,setModalAbierto,titulo,regisMaquinaria,funcionActuliza, regInci}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [radioTipo, setRadioTipo] = useState("1"); 
  const [fechasSeleccionadas, setFechasSeleccionadas] = useState({inicio: new Date(), });
  const [nvActividad,guardarNvActividad]= useState({Orden:0, Descripcion:'',Marca:'', Tipo:""});  
  const {Orden,  Descripcion,Marca, Tipo}=nvActividad      
  const [listTipo, setListTipo] = useState([])  
  
  React.useEffect(()=>{           
    if (regInci.length!==0) {
      guardarNvActividad({
        ...nvActividad, Orden:regInci.Id
      })                       
    }
    
    getListTipo()
 
    return ()=> {
      source.cancel();
    }     
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

 
  const getListTipo = (   ) => {
    const data = qs.stringify({
      Usuario:idusu,      
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/incidencia/tipo";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListTipo(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  };    

  const registrarNActividad=(FCaptura)=>{               
  
    //let NomUsu= localStorage.getItem('UsuarioNom');  
    const data = qs.stringify({
      Llave:Orden,
      Usuario:idusu,
      Maquinaria:regisMaquinaria.Id,
      Status:1,      
      Tipo:Tipo!=="" ? Tipo:0,
      Descr:Descripcion,
      FCaptura:FCaptura,
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/maquinaria/incidencia/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje='Se registro correctamente.'
        if (Orden!==0) {
          mensaje='Se edito correctamente.'
        }
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza(regisMaquinaria.Id)
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeDesc = e =>
  {      
    guardarNvActividad({
      ...nvActividad,
      [e.target.name] : e.target.value  
    })
    if (aviso) 
    {
      setMensaje('');
      setAviso(false);
    }    
  };

  const onChangeSelect = e =>
  {
     
    guardarNvActividad({
      ...nvActividad,
      [e.target.name] : e.target.value  
    })
  };

  const guardTerminal = e =>
  {
    guardarNvActividad({
      ...nvActividad,
      [e.target.name] : e.target.value  
    })
  };

  const onChangeRad=(e)=>{
    setRadioTipo(e.target.value)                    
  }
 

  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { setTipoAdvertencia("warning")    
      setMensaje(mensaje);
      setAviso(true)     
    }
    return respuesta
  }

  const guardarDatos = () => 
  {const fecha = moment(fechasSeleccionadas.inicio).format("YYYY-MM-DD")
    if ( ((Descripcion.length>=5 && validaDatos(Descripcion, "Llenar campo de Nota (mayor a 5 caracteres)") ))
        || (Descripcion.length<5 && validaDatos(0, "Llenar campo de Nota (mayor a 5 caracteres)"))
        ) 
    { registrarNActividad(`${fecha}T00:00:00`)                                   
    }                                           
  };

  const radioCampos=()=>{          
    return(    
    <FormControl component="fieldset" size="small" style={{marginLeft:.5+'rem', width:"20rem" }}>          
      <FormLabel size="small" >{`Tipo`}</FormLabel>        
      <RadioGroup  row aria-label="position"  defaultValue="top"
        name={`radioTipo`} value={radioTipo} onChange={onChangeRad} size="small"
      >                      
        <FormControlLabel value={"1"}  label={ "Bitácora"} 
          control={<Radio color="primary"  />} />                                   
        <FormControlLabel value={"2"}  label={ "Refacción"} 
          control={<Radio color="primary"  />} />          
      </RadioGroup>                     
    </FormControl>   
    )
  
  }

    return ( 
    <Modal
      titulo={titulo} modalAbierto={modalAbierto}
      setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
      mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
      aviso={aviso} setAviso={setAviso} espera={espera} 
      setEspera={setEspera}  tamanio={"sm"} btnDesact={btnDesact}
    >
      <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:30+'rem'}} > 
      <Box>
        <Relojes fechasSeleccionadas={fechasSeleccionadas} setFechasSeleccionadas={setFechasSeleccionadas} />
      </Box>
       <Box display="flex" flexDirection="column">                
       {  listTipo.length!==0 ?
        <FormControl className={classes.formControl} size="small" style={{width:20+'rem'}}>
          <InputLabel htmlFor="age-native-simple" style={{width:20+'rem'}}>Tipo</InputLabel>
          <MaterialSelect style={{width:20+'rem'}}
            native value={Tipo}
            onChange={onChangeSelect}
            inputProps={{ name: 'Tipo', id: 'Tipo', }}            
          >
            <option aria-label="None" value="" />      
            {listTipo.map((row) => (
              <option value={row.Id}>{row.Nom}</option>
            ))}   
          </MaterialSelect>
        </FormControl>
        :null  }               
      </Box> 
   
      <Box>
        <Typography component="p" variant="body2" color='primary' 
          style={{margin:0,marginLeft:.5+'rem'}} >
          Descripción
        </Typography>   
        <FormControl component="fieldset" style={{width:30+'rem'}}>    
          <textarea id="Descripcion-TextArea" name="Descripcion" rows="5"
            cols="100" placeholder="Descripción" style={{width: 30+"rem",borderRadius:3+'px'}} 
            value={Descripcion} onChange={onChangeDesc} 
          />
        </FormControl>
      </Box>
    </form>
  </Modal>
  );
}
 
export default NvoEditIncidencia;